import { Component, OnInit } from '@angular/core';
import { ConfLobControlService } from '../../Services/conf-lob-service/conf-lob-control.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { Store, select } from '@ngrx/store';
import {  getStepBarState } from '../../../../configurator-app/conf-store/reducer/stepbar.reducer';
import { getAllState } from '../../../../configurator-app/conf-store/reducer';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-conf-footer',
  templateUrl: './conf-footer.component.html',
  styleUrls: ['./conf-footer.component.scss']
})
export class ConfFooterComponent implements OnInit {
  confAWSUrlStr: any = environment.confAWSurl;
  stepBarState!: any;
  selectedLob: any;
  constructor(public dialog: MatDialog, private _dataLobService: ConfLobControlService, private router: Router, private route: ActivatedRoute, private store: Store) {
    this.store.pipe(select(getStepBarState))
      .subscribe(data => {
        this.stepBarState = data;
      });

  }

  updateprogressstatus: Subscription = new Subscription();
  current_status: number = 0
  lob: any = ""
  footerStatus: boolean = true;

  button_status: boolean = false;
  lobMailId: any = "";

  next_button_event: Subscription = new Subscription();
  stepTitle: any = ""

  ngOnInit(): void {
    this.store.pipe(select(getAllState)).subscribe((state: any) => {
      this.selectedLob = state?.stepBarState?.selectedConfLob

      if(this.selectedLob == 'hcv'){
        this.lobMailId = "HCV_Newproducts@tatamotors.com";
      }else if(this.selectedLob == 'ilmcv'){
        this.lobMailId = "ILMCV_Newproducts@tatamotors.com";
      }else if(this.selectedLob == 'scv'){
        this.lobMailId = "SCVPU_Newproducts@tatamotors.com"
      }else{
        this.lobMailId = "Buses_Vans_Newproducts@tatamotors.com"
      }
      let currentStep = state?.stepBarState?.currentStep
      this.stepTitle = state?.stepBarState?.stepArr[currentStep]?.title
    })
  }
}
